/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import type { Theme } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

type Props = {
  image?: string;
  partnerName?: string;
};

const styles = {
  image: (theme: Theme) => css`
    max-width: 100%;
    height: 45px;
    ${theme.breakpoints.down('sm')} {
      height: 36px;
    }
  `,
};

const HeroPartnerLogo = ({ image, partnerName }: Props) => {
  if (!image) {
    return null;
  }

  return <Imgix src={image} alt={partnerName || _t('Partner')} maxHeight={45} css={styles.image} />;
};

export default HeroPartnerLogo;
